export default __webpack_public_path__ + "static/media/quiz_bg_mobile.548f009f.png";